// extracted by mini-css-extract-plugin
export default {"page":"loading-page_page__jL-Ux","container":"loading-page_container__ACRU7"};